import { getStore } from "../stores/base";
import { errorMsg, msgData } from "./utils";
import { DEFAULTS } from "./constants";

export const getPopupParameter = (pageId, data) => {
  try {
    const usePageStore = getStore(`runtime_page_${pageId}`);
    let popupId =
      data.popupId === DEFAULTS.POPUP_ID
        ? usePageStore.getState().getActivePopup().id
        : data.popupId;
    const popupCtx = usePageStore.getState().popupContext[popupId];
    return msgData(data, {
      value: popupCtx?.[data.key]
    });
  } catch (e) {
    return errorMsg(e);
  }
};

export const getAllPopupParameters = (pageId, data) => {
  try {
    const usePageStore = getStore(`runtime_page_${pageId}`);
    let popupId =
      data.popupId === DEFAULTS.POPUP_ID
        ? usePageStore.getState().getActivePopup().id
        : data.popupId;
    const popupCtx = usePageStore.getState().popupContext[popupId];
    return msgData(data, popupCtx);
  } catch (e) {
    return errorMsg(e);
  }
};
